import { types, getRoot } from 'mobx-state-tree';

export default types.model('LanguageUrl', {
    HrefLang: types.string,
    LanguageCode: types.string,
    Url: types.string,
    SearchUrl: types.string,
    LanguageDefault: types.optional(types.boolean, false)

}).views(self => ({

    get navigation() {
        return getRoot(self).navigation;
    },

    FullUrl(currentUrl) {
        
        return self.navigation.baseUrl + (
            self.navigation.singleProduct
                ? self.SearchUrl + "/p/" + self.navigation.getSkuAndNameFromLocation()
                : self.Url);
        //return self.navigation.baseUrl + (
        //    self.navigation.singleProduct
        //        ? self.SearchUrl + "/p/" + self.navigation.singleProduct.Sku + "/" + self.navigation.singleProduct.UrlName
        //        : self.Url);
    },
    RemoveURLParameter(url, parameter) {
        if (!url || url.indexOf("?") < 0) {
            return url;
        }

        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    },
    BaseUrl() {

        let baseUrl = self.navigation.baseUrl + (
            self.navigation.singleProduct
                ? self.SearchUrl + "/p/" + this.RemoveURLParameter(self.navigation.getSkuAndNameFromLocation(), "return")
                : self.Url);


        if (baseUrl.indexOf(":Color") > -1) {
            baseUrl = baseUrl.replace(/:Color=(\w+)/, "");
        }

        return baseUrl;
        //return self.navigation.baseUrl + (
        //    self.navigation.singleProduct
        //        ? self.SearchUrl + "/p/" + self.navigation.singleProduct.Sku + "/" + self.navigation.singleProduct.UrlName
        //        : self.Url);
    }

})).actions(self => ({

}));
